<template>
    <div class="content">
        <ContentDoc path="/entry/hi" />
        <ContentDoc path="/devlog" />
    </div>
</template>

<style>
img {
    max-width: 100%
}
</style>